"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _InterestPaymentsHeaderFormComponent = _interopRequireDefault(require("./InterestPaymentsHeaderFormComponent"));
var _paginationActions = require("../../../redux/actions/paginationActions");
var _productPositionSelectors = require("../../../redux/selectors/productPositionSelectors");
var _interestAccountActions = require("../../../redux/actions/interestAccountActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FORM = 'interest-payments';
var mapStateToProps = function mapStateToProps(state) {
  var formValue = (0, _reduxForm.formValueSelector)(FORM);
  return {
    endDate: formValue(state, 'endDate'),
    products: (0, _productPositionSelectors.productPositionAssetsSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getInterestBalances: function getInterestBalances() {
      return dispatch((0, _interestAccountActions.getInterestBalances)());
    },
    setEndDate: function setEndDate(value) {
      return dispatch((0, _reduxForm.change)(FORM, 'endDate', value));
    },
    clearFilters: function clearFilters() {
      dispatch((0, _reduxForm.change)(FORM, 'startDate', null));
      dispatch((0, _reduxForm.change)(FORM, 'endDate', null));
      dispatch((0, _reduxForm.change)(FORM, 'product', 'all'));
    },
    resetActivePage: function resetActivePage() {
      return dispatch((0, _paginationActions.setActivePage)({
        componentName: 'InterestPaymentsTable',
        activePage: 0
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InterestPaymentsHeaderFormComponent["default"]);